import styled from "styled-components";

export const ScreenOptionStyled = styled.div`   
    position: relative;
    width: 100%;    
`;